import AsyncLoader from "./AsyncLoader";
import { Image } from "./image";
import { Link } from "react-router-dom";
import useSWR from "swr";

const apiUrl = process.env.REACT_APP_BACKEND_URL;
const apiToken = process.env.REACT_APP_API_TOKEN;

const fetcher = (url) =>
  fetch(url, {
    headers: {
      "x-api-key": apiToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error("Failed to load projects");
    }
    return res.json();
  });

export const Gallery = () => {
  const { data, error, isLoading } = useSWR(`${apiUrl}projecten`, fetcher, {
    errorRetryCount: 5,
    errorRetryInterval: 3000,
    shouldRetryOnError: true,
  });

  const projects = data?.items ?? [];

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Realisaties</h2>
        </div>

        <AsyncLoader loading={isLoading} error={error?.message}>
          <div
            className="portfolio-items"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            {projects.map((d, i) => (
              <div
                key={`${d.naam}-${i}`}
                className="gallery-item"
                style={{ flex: "0 0 45%",maxWidth: "45%" }}
              >
                <Link
                  to={`/project/${d.id}`}
                  style={{ textDecoration: "none" }}
                >
                  <Image title={d.naam} Image={d.photos?.[0]?.path} id={d.id} />
                </Link>
              </div>
            ))}
          </div>
        </AsyncLoader>
      </div>
    </div>
  );
};

